export default {
	getUserProfile(state){
		return state.user
	},
	isLoggedIn: state => !!state.token,
	isAdmin: state => state.isAdmin,
	authStatus: state => state.status,
	// fetchGoogleObject(state){
	// 	console.log('this is google object : ', state)
	// },
	getCurrentResources(state){
		const { activeResource, itemsPerPage, lists } = state
		console.log('getter : ',activeResource, itemsPerPage, lists[activeResource].status)

		const page = Number(state.route.params.page) || 1
		const start = (page - 1) * itemsPerPage
		const end = page * itemsPerPage

		return lists[activeResource];
	},
	// ids of the items that should be currently displayed based on
	// current list type and current pagination
	activeIds (state) {
		const { activeType, itemsPerPage, lists } = state

		if (!activeType) {
			return [1,2,3]
		}

		const page = Number(state.route.params.page) || 1
		const start = (page - 1) * itemsPerPage
		const end = page * itemsPerPage

		return lists[activeType].slice(start, end)
	},

	// items that should be currently displayed.
	// this Array may not be fully fetched.
	activeItems (state, getters) {
		return getters.getCurrentResources
	},
	getCurrentTransaction (state) {
		return state.transaction
	}
}



// WEBPACK FOOTER //
// src/store/getters.js